import React from 'react';
import styled from 'styled-components';
import {FlexRow, FlexColumn, zIndexOnTopOfAll, Icon} from '../../StyledUtils';
import {AppleLink, GoogleLink, InstallButtonContainerRow} from '../buttons/InstallContainer/StyledInstallContainer';
import {CheckmarkSVG} from '../../images/icons/checkmark.svg';

export const PopupContainer = styled(FlexColumn)`
  background: rgba(19, 26, 45, 0.95);
  height: 100%;
  width: 100%;
  position: fixed;
  bottom: 0px;
  z-index: ${zIndexOnTopOfAll};
  transition: opacity 0.3s ease-in-out;
  pointer-events: 'all';
  justify-content: space-between;
  align-items: center;
  ${InstallButtonContainerRow} {
    justify-content: start;
    margin: 30px 0px 14px 0px;
  }
  ${GoogleLink}, ${AppleLink} {
    width: 144px;
    height: 42px;
    margin-bottom: 0px;
    }
  #wot-install-button {
    min-width: 180px;
    height: 48px;
    background-color: #4989f4;
    &:hover {
        background-color: #036bdf;
    }
  }
`;

export const CenterContainer = styled(FlexRow)`
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    margin-left: 54px;
`;

export const StyledPromoContentContainer = styled(FlexColumn)`
    justify-content: space-between;
    max-width: 500px;
    max-height: 700px;
    padding: 50px;
`;

export const Title = styled.span`
  font-size: 48px;
  color: white;
  font-weight: bold;
  margin: 10px 0px;
`;

export const SubtitlesContainer = styled(FlexColumn)`
    margin: 10px 0px 30px 0px;
`;

export const Checkmark = styled(Icon).attrs({
    children: <CheckmarkSVG />
    })`
        align-self: center;
`;

export const Subtitle = styled.span`
  font-size: 18px;
  color: white;
  margin: 5px;
`;

export const StyledStarsReviewsContainer = styled(FlexRow)`
    align-items: center;
    margin: 14px 0px 10px 0px;
`;

export const FullStarsRow = styled.img.attrs({
    src: '/images/stars/5-full-stars.svg',
    alt: 'WOT Review Stars'
})`
    width: 120px;
    height: 24px;    
`;

export const StoreReviewsText = styled.span`
  font-size: 15px;
  color: white;
  font-weight: bold;
  margin: 5px 10px 0px;
`;

export const PromoText = styled.span`
  font-size: 15px;
  color: white;
`;

export const WOTLaptop = styled.img.attrs({
    src: '/images/popup/wot-laptop-tinified.png',
    alt: 'WOT Laptop'
})`
    width: 452px;
    height: 473px;
    padding: 50px;    
`;

export const CloseCircle = styled.img.attrs({
    src: '/images/icons/xcircle.svg',
    alt: 'Close circle',
    'data-automation': 'icon',
})`
    align-self: flex-end;
    cursor: pointer;
    margin: 30px 30px auto 0px;
    width: 24px;
    height: 24px;
`;
